import { Component } from '@angular/core';
import { HomeBanner } from '../../components/home/home-banner/home-banner';
import { HomeCategories } from '../../components/home/home-categories/home-categories';
import { HomeDesignedDetails } from '../../components/home/home-designed-details/home-designed-details';
import { HomeJoin } from '../../components/home/home-join/home-join';
import { HomeNewArrivals } from '../../components/home/home-new-arrivals/home-new-arrivals';
import { HomeStory } from '../../components/home/home-story/home-story';
import { TitleService } from '../../services/title.service';
@Component({
  selector: 'app-home-page',
  imports: [HomeBanner, HomeStory, HomeCategories, HomeDesignedDetails, HomeNewArrivals, HomeJoin],
  templateUrl: './home-page.html',
  styleUrl: './home-page.scss',
})
export class HomePage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('');
  }
}
